import { useAuth } from '@/contexts/AuthContext';
import { useEditMode } from '@/contexts/EditModeContext';
import { Button } from '@/components/ui/button';
import { Edit, Eye, LogOut } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const EditModeToggle = () => {
  const { user, isEditor, isAdmin, signOut, loading } = useAuth();
  const { isEditMode, toggleEditMode } = useEditMode();

  console.log('🎛️ EditModeToggle render:', { loading, hasUser: !!user, isEditor, isAdmin });

  // Don't render until auth is fully loaded
  if (loading || !user || !isEditor) {
    console.log('❌ Not rendering toggle:', { loading, hasUser: !!user, isEditor });
    return null;
  }
  
  console.log('✅ Rendering EditModeToggle');

  return (
    <div className="flex items-center gap-2">
      <Button
        onClick={toggleEditMode}
        variant={isEditMode ? 'default' : 'outline'}
        className={`shadow-lg transition-all ${
          isEditMode ? 'bg-orange-500 hover:bg-orange-600' : ''
        }`}
      >
        {isEditMode ? (
          <>
            <Edit className="h-4 w-4 mr-2" />
            Edit Mode ON
          </>
        ) : (
          <>
            <Eye className="h-4 w-4 mr-2" />
            Edit Mode OFF
          </>
        )}
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="shadow-lg">
            <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
              {user.email?.[0].toUpperCase()}
            </div>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium">{user.email}</p>
              <Badge variant="secondary" className="w-fit text-xs">
                {isAdmin ? 'Admin' : 'Editor'}
              </Badge>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={signOut} className="text-red-600">
            <LogOut className="h-4 w-4 mr-2" />
            Sign Out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
